import * as API from '@/services/API';

export default {
  get(id) {
    return API.apiClient.get(`/staff-member/${id}`);
  },
  list(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/staff-member/${query}`);
  },
  paginate(link) {
    return API.apiClient.get(link);
  },
  search(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/staff-member/search${query}`);
  },
  async save(id, data) {
    if (id == 0) {
      return API.apiClient.post(`/staff-member`, data);
    } else {
      return API.apiClient.put(`/staff-member/${id}`, data);
    }
  },
  async delete(id) {
    return API.apiClient.delete(`/staff-member/${id}`);
  }
};
